<template>
    <div class="navigation">
        <input type="checkbox" class="navigation__checkbox navigation__nlpcheckbox" id="nlp-rec-toggle">
        <label ref="navigation__nlpbutton" for="nlp-rec-toggle" class="navigation__button">
            <span class="navigation__icon">&nbsp;</span>
        </label>
        <div class="navigation__background">&nbsp;</div>
        <nav class="navigation__nav __nav-r">
            <section class="section-tours" id="section-tours">
                <div class="row myview">
                    <div class="">
                        <div class="card">
                            <div class="card__side card__side--front">
                                <div class="card__picture card__picture--2">&nbsp;
                                    <h4 class="card__heading">
                                        <span class="card__heading-span card__heading-span--1">
                                            Recommender System
                                        </span>
                                        <br>

                                        <span class="card__heading-span card__heading-span--2">
                                            (Content-based)
                                        </span>
                                    </h4>
                                </div>
                                <div id="card1Details" class="card__details" style="overflow-y: auto; height: 50vh;padding-bottom:20rem;">
                                    <div class="u-center-text u-margin-bottom-medium row myview sum-rec">
                                        <h2 class="heading-secondary" @click="navigateToURL(url)"
                                            style="cursor: pointer;">
                                            {{title}}
                                        </h2>
                                    </div>
                                    <ul>
                                        <template v-if="getRecommended.length>0">
                                            <h1  style="text-align: left;font-size: 2.5rem;margin-left:1rem;">
                                                Recommended Related Articles:
                                            </h1>
                                        </template>
                                        <template v-if="getRecommended.length===0">
                                            <img src="../assets/loading.gif" alt="">
                                        </template>

                                        <template v-for="(s,i) in getRecommended">
                                            <li v-bind:key="i">
                                                <a class='card__link' :href="s.url" target="_blank">{{s.title}}</a>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </nav>
    </div>
</template>

<script>
    export default {
        components: {},
        computed: {
            getRecommended() {
                return !this.$store.getters.recommendedArticles ? this.data : this.$store.getters.recommendedArticles;
            }
        },
        data() {
            return {
                title: String,
                url: String
            }
        },
        created() {
            this.$eventHub.$on('nlp-recommended', this.getRecommendedArticles);
        },
        methods: {
            getRecommendedArticles(data) {
                this.title = data.title;
                this.url = data.url;
                document.getElementById('card1Details').scrollTop = 0;
                this.$store.dispatch('recommendedArticles', data);
            },
            navigateToURL(url) {
                window.open(url, '_blank')
            },
        }
    }
</script>

<style scoped>
    .loader {
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid darkgreen;
        border-bottom: 16px solid darkgreen;
        width: 120px;
        height: 120px;
        -webkit-animation: spin 1s linear infinite;
        animation: spin 1s linear infinite;
        margin-left: auto;
        margin-right: auto
    }

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }


</style>
